import React from "react";
import { useAppSelector } from "../../BusinessObjects/Redux/app/hook";
import { RootState } from "../../BusinessObjects/Redux/app/store";
import useWebSocket from "react-use-websocket";
type Props = {};

const CLOSE_WSS_CODE = 1000;

const WebSocketController = (props: Props) => {
  //Public API that will echo messages sent to it back to the client
  // const [socketUrl, setSocketUrl] = React.useState(WSS_URL);
  // const [messageHistory, setMessageHistory] = React.useState([]);

  const isLoggedIn = useAppSelector(
    (state: RootState) => state.user.isLoggedIn
  );
  const sessionId = useAppSelector((state: RootState) => state.user.sessionID);
  const tokenApi = useAppSelector((state: RootState) => state.user.tokenAPI);
  const wssUrl = useAppSelector((state: RootState) => state.app.wssUrl);

  const { sendMessage, lastMessage, readyState, getWebSocket } = useWebSocket(
    wssUrl,
    {
      onOpen: () => {
        // console.log('WSS opened')
      },
      //Will attempt to reconnect on all close events, such as server shutting down
      shouldReconnect: (closeEvent) => true,
      onClose: (closeEvent) => {
        if (closeEvent.code === CLOSE_WSS_CODE) {
          // console.log('WSS closed')
        }
      },
    }
  );

  React.useEffect(() => {
    if (isLoggedIn) {
      if (readyState === WebSocket.OPEN) {
        // Apertura connessione
        let message = {
          access_token: tokenApi,
          Session_ID: sessionId,
          // Type: 'Login'
        };
        sendMessage(JSON.stringify(message));
      }
    } else {
      if (readyState === WebSocket.OPEN) {
        // Chiusura connessione
        getWebSocket()!.close();
        // sendMessage(JSON.stringify({ Type: 'Logout' }))
      }
    }
  }, [isLoggedIn, readyState, wssUrl]);

  return null;
};

export default WebSocketController;
